import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { ParamService } from './param.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscoveryService {
  public windowObj: any = window;
  private banner: string;
    
userInfo: any;
  public isUserLoggedIn: boolean = false;
  private HTTP_OPTIONS = { headers: new HttpHeaders(this.windowObj['AB']?.j4uHttpOptions) };
  init() {
    if (this.windowObj['AB']?.j4uHttpOptions) {
      this.HTTP_OPTIONS = { headers: new HttpHeaders(this.windowObj['AB'].j4uHttpOptions) };
    }
}

  constructor(
    private http: HttpClient,
    private paramService: ParamService
  ) {
    this.banner = this.paramService.resolveBanner() || this.windowObj['AB']?.userInfo?.banner;
  }

  /**
   * Get Discovery content properties from AEM
   * Similar to getMyListHTMLProperties in my-list.service.ts
   */
  public getDiscoveryHTMLProperties(): any {
    const aemPropsEle = document.getElementById('aemDiscoveryProps');
    const aemDiscoveryProps = aemPropsEle?.getAttribute('data-aem-config');

    if (!aemDiscoveryProps) {
      return undefined;
    }

    try {
      const parsedJSONData = JSON.parse(aemDiscoveryProps);
      return parsedJSONData?.discoveryProps?.bannerProps?.[this.banner] || parsedJSONData;
    } catch (e) {
      console.error('Failed to parse aemDiscoveryProps', e);
      return undefined;
    }
  }

  getEnvironment() {
        let environment;
        if (window.location.origin.indexOf('qa1') > 0 || window.location.origin.indexOf('qa2') > 0 || window.location.origin.indexOf('qa3') > 0 || window.location.origin.indexOf('stage') > 0) {
            environment = window.location.host.split('-')[1].split('.')[0];
        } else if (window.location.origin.indexOf('local') > 0) {
            environment = 'qa1';
        } else {
            environment = 'prod';
        }
        return environment;
    }

  /**
   * Get all discovery content properties
   */
  public getAllDiscoveryProperties(): any {
    const aemPropsEle = document.getElementById('aemDiscoveryProps');
    const aemDiscoveryProps = aemPropsEle?.getAttribute('data-aem-config');

    if (!aemDiscoveryProps) {
      return undefined;
    }

    try {
      return JSON.parse(aemDiscoveryProps);
    } catch (e) {
      console.error('Failed to parse aemDiscoveryProps', e);
      return undefined;
    }
  }
 public getCurrentYearSavings() {
        const wwwHost = this.windowObj['SWY']?.CONFIGSERVICE?.bannerDomainMap?.["www-" + this.banner];
        const apiPath = this.windowObj['AB']?.savingsAPIPath;
        if (!wwwHost || !apiPath) {
            return throwError(() => new Error('savingsAPIPath or wwwHost is not available'));
        }
        const url = `${wwwHost}${apiPath}`;
        // Clone HTTP_OPTIONS and append additional headers
        const modifiedHttpOptions = {
            ...this.HTTP_OPTIONS,
            headers: this.HTTP_OPTIONS.headers
                .set('X-Service-Name', 'DiscoveryService')
                .set('X-Function-Name', 'getCurrentYearSavings')
        };
        return this.http.get(url, modifiedHttpOptions).pipe(
            map((data: any) => {
                return data;
            }, catchError(this.handleError))
        )
    }
     public handleError(errorResponse: HttpErrorResponse) {
            if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
                console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
                const errCode = errorResponse.error.code && errorResponse.error.message ? errorResponse.error.code : errorResponse.status;
                return throwError(errCode);
            }
            return throwError(errorResponse.error); // Add this line to return a value in case the condition is not met
        }

        public getRewardsPointsBalance() {
            const wwwHost = this.windowObj['SWY']?.CONFIGSERVICE?.bannerDomainMap?.["www-" + this.banner];
            const apiPath = this.windowObj['AB']?.ocrpRewardScorecard;
            if (!wwwHost || !apiPath) {
                return throwError(() => new Error('ocrpRewardScorecard or wwwHost is not available'));
            }
            const url = `${wwwHost}${apiPath}`;
            const httpOptions = {
                headers: new HttpHeaders(this.windowObj['AB']?.xAPIOcrpRewardsHttpOptionsV3 || {})
                    .set('X-Service-Name', 'DiscoveryService')
                    .set('X-Function-Name', 'getRewardsPointsBalance')
            };
            const body = {
                hhid: this.windowObj['AB']?.userInfo?.houseId,
                programType: ['BASEPOINTS']
            }
            let rewardBalance: number = 0;
            return this.http.post(url, body, httpOptions).pipe(
                map((data: any) => {
                    if (data && data['scorecards'] && data['scorecards'].length) {
                        data['scorecards'].forEach((scorecard: any) => {
                            if (scorecard && scorecard['programType'] === 'BASEPOINTS') {
                                rewardBalance = scorecard['balance'];
                            }
                        })
                    }
                    return rewardBalance;
                }, catchError(this.handleError))
            )
        }


 

  /**
   * Get personalized deals from the discovery API
   * @param requestBody - Complete request body object to be sent to the API
   * @returns Observable with API response
   */
  getZonesData(requestBody: any, options?: { skipLogging?: boolean; zoneType?: string }): Observable<any> {
    const wwwHost = this.windowObj['SWY']?.CONFIGSERVICE?.bannerDomainMap?.["www-" + this.banner];
    
    
    const envKey = this.getEnvironment();
    
    const apiPath = (environment as any)[envKey]?.discoveryAPIPath;
    if (!wwwHost || !apiPath) {
      return throwError(() => new Error('discoveryAPIPath or wwwHost is not available'));
    }
    const url = `${wwwHost}${apiPath}`;

    let headerObj = (environment as any)[envKey]?.discoveryAPIConfig?.httpHeaders;

    
    // Get headers from environment configuration
    let headers = new HttpHeaders(headerObj);
    if (options?.skipLogging) {
      headers = headers.set('X-Skip-Logging', 'true');
    }
    if (options?.zoneType) {
      headers = headers.set('X-Zone-Type', options.zoneType);
    }

    const httpOptions = {
      headers
    };
    
    return this.http.post(url, requestBody, httpOptions).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}